<template>
    <div id="UI_Dialog_Alert" class="modal" style="display:block;">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <div class="modal-title">{{title}}</div>
                </div>
                <div class="modal-body" style="word-break: break-all;" v-html="mes"></div>
                <div class="modal-footer">
                    <!-- <button type="button" class="btn btn-primary" @click.stop="closeAlert">确定</button> -->
                    <button type="button"  
                        v-for="(btn,index) in btns" 
                        :key="index" 
                        :class="['btn',btn.btnColor?btn.btnColor:'']" 
                        @click="(e)=>clickFn(e,btn)" >{{btn.text}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
    export default {
        data() {
            return {
                title: "提示信息",
                mes: "",
                btns: [
                    {
                        text: "确定",
                        btnColor: "btn-primary",
                        callback: () => console.log('yes')
                    },
                    {
                        text: "取消",
                        btnColor: "btn-danger",
                        callback: () => console.log('no')
                    }
                ]
            }
        },
        methods: {
            clickFn (event, btn) {
                this.$el.remove(); // 移除DOM
                const {
                    callback = () => console.warn("请传入回调函数")
                } = btn;
                callback(event, btn); // 传递回去
            }
        }
    }
</script>

<style lang="less">

</style>
